import { DataTestPanelBody } from './DataTestPanelBody';
import { DataTestPanelFooter } from './DataTestPanelFooter';
import { DataTestPanelProvider } from './DataTestPanelProvider';
import { DataTestProvider } from './useDataTest/DataTestProvider';
import { useDataTest } from './useDataTest/useDataTest';
import { BasePanel } from '../Panel/BasePanel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DataTest(props) {
  return /*#__PURE__*/_jsx(DataTestPanelProvider, {
    children: /*#__PURE__*/_jsx(DataTestProvider, Object.assign({}, props, {
      children: /*#__PURE__*/_jsx(DataTestPanelInternal, {})
    }))
  });
}
export function DataTestPanelInternal() {
  const {
    onClose
  } = useDataTest();
  return /*#__PURE__*/_jsxs(BasePanel, {
    inlineSize: 680,
    isOpen: true,
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(BasePanel.Header, {
      children: /*#__PURE__*/_jsx(BasePanel.Heading, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dataTest.panel.title"
        })
      })
    }), /*#__PURE__*/_jsx(DataTestPanelBody, {}), /*#__PURE__*/_jsx(DataTestPanelFooter, {})]
  });
}